<template>
  <div class="nlp__why-check-box">
    <h2>
      Why Checking Wallets Matters
    </h2>
    <div class="nlp__why-check-cards">
      <div
        v-for="(item, index) in whyCheckData"
        :key="index"
        class="nlp__why-check-card"
      >
        <div class="nlp__why-check-card-img">
          <img
            :alt="item.alt"
            :src="item.image"
          >
        </div>
        <div class="nlp__why-check-card-text">
          <h3>
            {{ item.title }}
          </h3>
          <p>
            {{ item.description }}
          </p>
        </div>
      </div>
    </div>
    <div class="nlp__button-box">
      <NlpButton
        primary
        text="Check Address"
        @button-click="$router.push({ name: 'source-of-funds' })"
      />
    </div>
  </div>
</template>

<script>
// Components
import NlpButton from '@/pages/landing-page/ui-components/NlpButton.vue'

// Images
import img1 from '@/assets/images/nlp/why-check-img1.png'
import img2 from '@/assets/images/nlp/why-check-img2.png'
import img3 from '@/assets/images/nlp/why-check-img3.png'

export default {
  name: 'NlpWhyCheck',
  components: {
    NlpButton,
  },
  data() {
    return {
      whyCheckData: [
        {
          title: 'Account Freezing',
          description: 'Exchanges can suspend accounts holding suspicious coins. Regular checks help ensure all crypto is clean and avoid freezing.',
          image: img1,
          alt: 'Frozen crypto wallet risk icon',
        },
        {
          title: 'Blocking Crypto',
          description: "Even 1 risky transaction can lead to blocking access to all associated assets. Mixing in just 1 ‘dirty’ coin can create problems.",
          image: img2,
          alt: 'Risk of blocking crypto transactions',
        },
        {
          title: 'Crypto Seizure',
          description: 'If authorities suspect illegal activity, they can freeze and even seize crypto for a long time. Getting money back can be slow and difficult.',
          image: img3,
          alt: 'Crypto seizure warning due to flagged activity',
        },
      ],
    }
  }
}
</script>

<style scoped>
.nlp__why-check-box h2 {
  margin-bottom: 60px;
}

.nlp__why-check-cards {
  display: flex;
  gap: 16px;
}
.nlp__why-check-card {
  flex: 1;
  min-width: 0;
  padding: 4px;
  background-color: #fff;
  border: 1px solid #E2E9F6;
  border-radius: 24px;
  box-shadow: 2px 2px 4px 0px #B8C2DB40;
}
.nlp__why-check-card-img {
  height: 150px;
  margin-bottom: 24px;
  border-radius: 18px;
  overflow: hidden;
}
.nlp__why-check-card-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.nlp__why-check-card-text {
  padding: 0 28px 28px 28px;
}
.nlp__why-check-card-text h3 {
  margin-bottom: 8px;
  text-align: left;
}
.nlp__why-check-card-text p {
  font-size: 16px;
  line-height: 26px;
}


@media (max-width: 1279px) {
  .nlp__why-check-box {
    max-width: 560px;
    margin: 0 auto;
  }
  .nlp__why-check-cards {
    display: block;
  }
  .nlp__why-check-card + .nlp__why-check-card {
    margin-top: 24px;
  }
  .nlp__why-check-card-text h3,
  .nlp__why-check-card-text p {
    text-align: center;
  }
}
@media (max-width: 767px) {
  .nlp__why-check-box h2 {
    margin-bottom: 40px;
  }
  .nlp__why-check-card-text {
    padding: 0 12px 12px 12px;
  }
  .nlp__why-check-card-text h3,
  .nlp__why-check-card-text p {
    text-align: left;
  }
}
</style>